import { useEffect, useState } from "react";
import { GlobalRequest } from "../../../../../../../common/services/request";
import { Loader } from "../../../../../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { Tabs } from "antd";
import { PointingDetailsContext } from "../../../../../core/_context";
import { OtherDetailsData } from "./OtherDetailsData";
import { OtherDetailsInfo } from "./OtherDetailsInfo";

type PropsType = {
  initialValue?: any;
};

export const OtherDetails = ({ initialValue }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [initialState, setInitialState] = useState<any>();

  /* const TAB_ITEMS = [
    {
      key: "DATA",
      label: "Données",
      children: <OtherDetailsData />,
    },
    {
      key: "INFO",
      label: "Informations",
      children: <OtherDetailsInfo />,
    },
  ]; */

  useEffect(() => {
    if (initialValue) {
      getContainer(initialValue?.["@id"]);
    }
  }, [initialValue]);

  const getContainer = async (url: string) => {
    try {
      setIsLoading(true);
      const res = await GlobalRequest.get(`${url}/controlled`);

      if (res?.status === HttpStatusCode.Ok) {
        setInitialState(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PointingDetailsContext.Provider
      value={{
        data: initialState,
      }}
    >
      <Loader isLoading={isLoading} />
      {/* <Tabs items={TAB_ITEMS} /> */}
      <OtherDetailsData />
    </PointingDetailsContext.Provider>
  );
};
